export const marketing = {
  marketStatus: [{
    value: 0, label: '未生效'}, {
    value: 1, label: '有效'}, {
    value: -1, label: '过期'
  }],
  feiCheCategory: [{
    value: 1, label: '指定产品名称'}, {
    value: 2, label: '指定产品方案'
  }],
  programme: [{
    value: 1, label: '现金比例', field: 'ratio'}, {
    value: 2, label: '现金折减', placeholder: '现金折减金额', field: 'cash'}, {
    value: 3, label: '储值', placeholder: '储值比例', field: 'stored', field1: 'reducedCosts1'}, {
    value: 4, label: '服务类', type: 'textarea', field: 'service', field1: 'reducedCosts2'}, {
    value: 5, label: '礼品', type: 'textarea', field: 'gift', field1: 'reducedCosts3'}, {
    value: 6, label: '服务项目'
  }],
  marketProjectStatus: [{
    value: 0, label: '有效'}, {
    value: 1, label: '禁用'// }, {
    // value: -1, label: '删除'
  }],
  // 参与对象
  joinObjectList: [{
    value: '1', label: '出单员' }, {
    value: '2', label: '业务员'
  }],
  // 投保人年龄区间
  customerAgeList: [{
    value: '1', label: '25岁及以下'
  }, {
    value: '2', label: '25岁-30岁(含)'
  }, {
    value: '3', label: '30岁-45岁(含)'
  }, {
    value: '4', label: '45岁-60岁(含)'
  }, {
    value: '5', label: '60岁以上'
  }],
  // 险种类型
  insuranceTypeList: [{
    value: '1', label: '单交'
  }, {
    value: '2', label: '交三'
  }, {
    value: '3', label: '交损'
  }, {
    value: '4', label: '单三'
  }, {
    value: '5', label: '单损'
  }],
  // 车辆权重种类
  vehicleWeightList: [{
    value: '1', label: '车辆类型'
  }, {
    value: '2', label: '车价'
  }, {
    value: '3', label: '座位数'
  }, {
    value: '4', label: '车龄'
  }, {
    value: '5', label: '排量'
  }, {
    value: '6', label: '能源类型'
  }, {
    value: '7', label: '所属性质'
  }, {
    value: '8', label: '使用性质'
  }, {
    value: '9', label: '车辆年限'
  }, {
    value: '10', label: '过户'
  }, {
    value: '11', label: '核载质量'
  }],
  // 人员权重种类
  customerWeightList: [{
    value: '1', label: '投保人'
  }, {
    value: '2', label: '被保人'
  }, {
    value: '3', label: '车主'
  }],
  // 车辆类型
  vehicleModelList: [{
    value: '1', label: '客车'
  }, {
    value: '2', label: '货车'
  }],
  // 车价区间
  carPriceRangeList: [{
    value: '1', label: '10万及以下'
  }, {
    value: '2', label: '10万-30万(含)'
  }, {
    value: '3', label: '30万-50万(含)'
  }, {
    value: '4', label: '50万-100万(含)'
  }, {
    value: '5', label: '100万-200万(含)'
  }],
  // 座位
  seatRangeList: [{
    value: '1', label: '5座及以下'
  }, {
    value: '2', label: '6-10座(不含)'
  }, {
    value: '3', label: '10座及以上'
  }],
  // 车龄区间
  carAgeRangeList: [{
    value: '1', label: '6年及以下'
  }, {
    value: '2', label: '6年-10年(含)'
  }, {
    value: '3', label: '10年-15年(含)'
  }, {
    value: '4', label: '15年-20年(含)'
  }, {
    value: '5', label: '20年以上'
  }],
  // 排量区间
  displacementRangeList: [{
    value: '1', label: '1.0L及以下'
  }, {
    value: '2', label: '1.0L-1.6L(含)'
  }, {
    value: '3', label: '1.6L-2.0L(含)'
  }, {
    value: '4', label: '2.0L-4.0L(含)'
  }, {
    value: '5', label: '4.0L以上'
  }],
  // 能源类型
  energyTypeList: [{
    value: '1', label: '燃油'
  }, {
    value: '2', label: '新能源'
  }],
  // 所属性质
  belongingNatureList: [{
    value: '1', label: '个人'
  }, {
    value: '2', label: '企业'
  }, {
    value: '3', label: '机关'
  }],
  // 使用性质
  useCharacterList: [{
    value: '1', label: '营业'
  }, {
    value: '2', label: '非营业'
  }, {
    value: '3', label: '家用'
  }, {
    value: '4', label: '事业团体用车'
  }, {
    value: '5', label: '党政机关用车'
  }],
  // 使用年限
  serviceLifeList: [{
    value: '1', label: '新车'
  }, {
    value: '2', label: '旧车'
  }],
  // 是否过户
  transferSettings: [{
    value: '1', label: '过户'
  }, {
    value: '2', label: '非过户'
  }],
  // 核载质量
  nuclearPayloadMass: [{
    value: '1', label: '1吨及以下'
  }, {
    value: '2', label: '1吨-2吨(含)'
  }, {
    value: '3', label: '2吨-10吨(含)'
  }, {
    value: '4', label: '10吨以上'
  }]
}

export default {
  marketing
}



// WEBPACK FOOTER //
// ./src/data/marketing.js